// removed by extract-text-webpack-plugin
module.exports = {"notice":"_1EkSOpSTRPYpkqPtD1Arj3","person":"_3pg0kMr6sKXln9APzNmzyB","intro":"_2XCe5Zc6WvFavajg2u1quW","photos":"_2qEBI3KuZ5fHgaqFAyOf53"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Contacts/Contacts.scss
// module id = 877
// module chunks = 0